import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /api/v1/payment/settlements?provider_type=doctor
// Returns the provider's settlement history so the UI can show pending requests.
export const fetchProviderSettlementsReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.fetch_provider_settlements,
  async (
    { provider_type = "doctor", page = 1, limit = 50 } = {},
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams({
        provider_type,
        page,
        limit,
      }).toString();

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getProviderSettlements}?${queryParams}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        // result shape: { data: [...], total, page, limit, total_pages }
        return response.data.data;
      }
      return rejectWithValue(getLocalizedErrorMessage({ response }, i18n));
    } catch (error) {
      console.error("Error fetching provider settlements:", error);
      return rejectWithValue(getLocalizedErrorMessage(error, i18n));
    }
  },
);
